﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

import type { GetSelfServiceLoginInfoResponse } from "~jrad/Services/API/Account/GetSelfServiceLoginInfo";
import type { PostSelfServiceLoginRegistrationResponseSuccess } from "~jrad/Services/API/Account/PostSelfServiceLoginRegistration";

//-------------------------------------------------------------------------------------
// Enums
//-------------------------------------------------------------------------------------

export enum SelfServiceLoginRegistrationPage {
    AccessDenied,
    TermsOfService,
}

//-------------------------------------------------------------------------------------
// Types
//-------------------------------------------------------------------------------------

export interface SelfServiceLoginViewState {
    errorMessage?: string;
    page: SelfServiceLoginRegistrationPage;
    nextPageAfterLoading: SelfServiceLoginRegistrationPage;

    waitForTextCodesToLoad?: boolean;

    requestData: SelfServiceLoginRequestData;

    loginInfo: GetSelfServiceLoginInfoResponse;

    responseHasError: boolean;
    responseData: Omit<
        PostSelfServiceLoginRegistrationResponseSuccess,
        "HasError"
    >;
    responseError: SelfServiceLoginErrorState;

    hasStoredAuthToken: boolean;
}

export type SelfServiceLoginErrorState = {};

export type SelfServiceLoginRequestData = {
    hasAcceptedToS: boolean;
};
